const state = {
  alert: {
    show: false,
    title: null,
    message: null,
  },
};

const getters = {};

const mutations = {
  showAlert(state, data) {
    state.alert = {
      show: true,
      title: data.title,
      message: data.message,
    };
  },

  closeAlert(state) {
    state.alert = {
      show: false,
      title: null,
      message: null,
    };
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
